/* ==========================================================================
   ZORA — Dynamic product rows
   related / complementary  → Shopify's recommendations endpoint
   recent                   → the shopper's own recently-viewed list
   A row that finds nothing removes itself rather than leaving a bare heading.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, r) {
    return (r || document).querySelector(s);
  }
  function $$(s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    if (window.Zora && window.Zora.formatMoney) return window.Zora.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  function remove(section) {
    var wrapper = section.closest('.shopify-section') || section;
    // In the theme editor, keep the section visible so it stays selectable
    if (window.Shopify && window.Shopify.designMode) {
      section.setAttribute('data-z-empty', 'true');
      return;
    }
    wrapper.remove();
  }

  /* ----------------------------------------------------------------------
     Shopify recommendations — render the section server-side and swap it in
     ---------------------------------------------------------------------- */
  function loadRecommendations(section) {
    var productId = section.getAttribute('data-product-id');
    var sectionId = section.getAttribute('data-section-id');
    var limit = section.getAttribute('data-limit') || 4;
    var intent = section.getAttribute('data-intent') || 'related';
    var target = $('[data-z-dynamic-target]', section);

    if (!productId || !sectionId || !target) {
      remove(section);
      return;
    }

    var url =
      '/recommendations/products?section_id=' +
      encodeURIComponent(sectionId) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      encodeURIComponent(limit) +
      '&intent=' +
      encodeURIComponent(intent);

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('recommendations unavailable');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-z-dynamic-target]');
        var items = fresh ? fresh.querySelectorAll('li') : [];

        if (!items.length) {
          remove(section);
          return;
        }

        target.innerHTML = fresh.innerHTML;
        if (window.Zora && window.Zora.initAll) window.Zora.initAll(section);
      })
      .catch(function () {
        remove(section);
      });
  }

  /* ----------------------------------------------------------------------
     Recently viewed — built from localStorage, verified against the catalog
     ---------------------------------------------------------------------- */
  function loadRecent(section) {
    var target = $('[data-z-dynamic-target]', section);
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 8;
    if (!target) return remove(section);

    var recent = (window.Zora && window.Zora.recent && window.Zora.recent.read()) || [];

    // Never recommend the product someone is already looking at
    var currentHandle =
      (window.ZoraTheme && window.ZoraTheme.currentProduct && window.ZoraTheme.currentProduct.handle) || null;

    var handles = recent
      .map(function (i) {
        return i.handle;
      })
      .filter(function (h, i, arr) {
        return h && h !== currentHandle && arr.indexOf(h) === i;
      })
      .slice(0, limit);

    if (!handles.length) return remove(section);

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var live = products.filter(Boolean);
      if (!live.length) return remove(section);

      var isCarousel = section.querySelector('.z-rail') !== null || section.getAttribute('data-layout') !== 'grid';
      var listClass = isCarousel ? 'z-rail' : 'z-product-grid';

      target.innerHTML =
        '<ul class="' +
        listClass +
        '">' +
        live.map(cardFor).join('') +
        '</ul>';

      if (window.Zora && window.Zora.initAll) window.Zora.initAll(section);
    });
  }

  function cardFor(p) {
    var variant =
      p.variants.find(function (v) {
        return v.available;
      }) || p.variants[0];

    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var url = '/products/' + p.handle;

    var priceHtml = onSale
      ? '<ins>' + money(p.price) + '</ins><del>' + money(p.compare_at_price) + '</del>'
      : '<span>' + money(p.price) + '</span>';

    var cta;
    if (!p.available) {
      cta = '<button type="button" class="z-btn z-btn--sm z-btn--block" disabled aria-disabled="true">Sold out</button>';
    } else if (p.variants.length === 1) {
      cta =
        '<button type="button" class="z-btn z-btn--sm z-btn--block" data-z-quick-add data-variant-id="' +
        esc(variant.id) +
        '" data-product-url="' +
        esc(url) +
        '" data-title="' +
        esc(p.title) +
        '">Add to cart</button>';
    } else {
      cta = '<a href="' + esc(url) + '" class="z-btn z-btn--sm z-btn--block z-btn--ghost">Choose options</a>';
    }

    return (
      '<li data-z-reveal data-z-stagger>' +
      '<div class="z-card" data-z-card data-handle="' + esc(p.handle) + '">' +
      '<div class="z-card__media">' +
      '<a href="' + esc(url) + '" class="z-media z-media--zoom" style="--z-ratio:125%" tabindex="-1" aria-hidden="true">' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async" width="400" height="500">' : '') +
      '</a>' +
      '<div class="z-card__actions">' +
      '<button type="button" class="z-icon-btn" data-z-wishlist-toggle data-handle="' + esc(p.handle) +
      '" data-product-id="' + esc(p.id) + '" data-title="' + esc(p.title) + '" data-url="' + esc(url) +
      '" data-image="' + esc(img) + '" data-price="' + esc(money(p.price)) +
      '" data-variant-id="' + esc(variant ? variant.id : '') + '" data-available="' + p.available +
      '" aria-pressed="false" aria-label="Add to wishlist">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.3l-1.4-1.3C5.9 14.8 3 12.2 3 8.9 3 6.3 5 4.3 7.6 4.3c1.5 0 2.9.7 3.8 1.8l.6.7.6-.7a5 5 0 0 1 3.8-1.8C19 4.3 21 6.3 21 8.9c0 3.3-2.9 5.9-7.6 10.1z"/></svg>' +
      '</button></div>' +
      (onSale ? '<div class="z-card__badges"><span class="z-badge z-badge--sale">Sale</span></div>' : '') +
      '</div>' +
      '<div class="z-card__body">' +
      (p.type ? '<p class="z-card__meta">' + esc(p.type) + '</p>' : '') +
      '<h3 class="z-card__title"><a href="' + esc(url) + '">' + esc(p.title) + '</a></h3>' +
      '<div class="z-card__price">' + priceHtml + '</div>' +
      '<div class="z-card__cta">' + cta + '</div>' +
      '</div></div></li>'
    );
  }

  /* ----------------------------------------------------------------------
     Boot — only when the row scrolls close, so it never blocks first paint
     ---------------------------------------------------------------------- */
  function start(section) {
    if (section.hasAttribute('data-z-loaded')) return;
    section.setAttribute('data-z-loaded', '');

    var source = section.getAttribute('data-source');
    if (source === 'recent') loadRecent(section);
    else loadRecommendations(section);
  }

  function boot() {
    var sections = $$('[data-z-dynamic-products]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(start);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          start(entry.target);
        });
      },
      { rootMargin: '600px 0px' }
    );

    sections.forEach(function (s) {
      io.observe(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-z-dynamic-products]');
    if (el) start(el);
  });
})();
